import { render, staticRenderFns } from "./BaseAsideMainNav.vue?vue&type=template&id=1bce83dc&scoped=true"
import script from "./BaseAsideMainNav.vue?vue&type=script&lang=js"
export * from "./BaseAsideMainNav.vue?vue&type=script&lang=js"
import style0 from "./BaseAsideMainNav.vue?vue&type=style&index=0&id=1bce83dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce83dc",
  null
  
)

export default component.exports